export const modules = [
  {
    id: "outreach",
    title: "Outreach",
    description: "Your CRM's missing engagement engine.",
    isPopular: true,
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/outreach/",
    },
    features: [
      "Multi-channel sequences",
      "Stay on top of your to-dos",
      "Performance insights with tracking",
    ],
  },
  {
    id: "conversations",
    title: "Conversations",
    description: "Connect, communicate and close.",
    features: [
      "All-in-one outreach with integrated Dialer",
      "Click-to-dial anywhere online",
      "Calls, SMS and Whatsapp in one workflow",
    ],
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/conversations/",
    },
  },
  {
    id: "data",
    title: "Data",
    description: "Better data. Faster.",
    features: [
      "One-click verified contact data",
      "Smart waterfall sourcing",
      "Built for both clients and candidates",
    ],

    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/data/",
    },
  },
  {
    id: "dataRefresh",
    title: "Data Refresh",
    description: "Turn old data into new deals.",
    features: [
      "Automated CRM/ATS data updates",
      "Effortless, background data enrichment",
      "Unlock repeat business and fast placements",
    ],
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/data-refresh/",
    },
  },
  {
    id: "extension",
    title: "Sourcing",
    description: "Find top candidates faster.",
    features: [
      "Save hours with AI-driven search",
      "Unlock value from your ATS/CRM",
      "Instant contact enrichment and outreach",
    ],
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/sourcing/",
    },
  },
  {
    id: "notetaker",
    title: "Notetaker",
    description: "Focus on the candidate, not the keyboard.",
    features: [
      "Automated call summaries",
      "Seamless CRM/ATS syncing",
      "Action-oriented insights",
    ],
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/notetaker/",
    },
  },
  {
    id: "inboxAgent",
    title: "Inbox Agent",
    description: "Power up your email inbox.",
    features: [
      "AI drafted replies",
      "Automated follow-up sequences",
      "Smart email coaching",
    ],
    secondaryCta: {
      label: "Learn more",
      link: "https://sourcewhale.com/inbox-agent/",
    },
  },
  {
    id: "projects",
    title: "Projects",
    // TODO: Add Projects Details
  },
];
